import React, {useEffect, useRef, useState} from 'react'
import {
  getConfigurationByName,
  updateConfigurationByConfigID,
} from '../../../../../../API/api-endpoint'
import ToastUtils, {ErrorToastUtils} from '../../../../../../utils/ToastUtils'
import { getImageBaseUrl } from '../../../../../../utils/Utils'

const MegaChatBotPlugin = () => {
  const hiddenFileInput = useRef<HTMLInputElement>(document.createElement('input'))

  const [configID, setConfigId] = useState(0)
  const [isImageUploaded, setisImageUploaded] = useState<any>(false)
  const [file, setFile] = useState('')
  const [megaChatBotConfig, setMegaChatBotConfig] = useState<any>({
    isGlobalChatBotEnabled: true,
    gestureImage: '',
    globalChatBotName: '',
    globalChatBotUrl: '',
  })

  useEffect(() => {
    getConfiguration()
  }, [])

  const handleChange = (event: any) => {
    let name = event.target.name
    let value = event.target.checked

    setMegaChatBotConfig({...megaChatBotConfig, gestureImage: file, [name]: value})
    updateConfiguration({...megaChatBotConfig, gestureImage: file, [name]: value}, null)
  }

  const getConfiguration = async () => {
    let result = await getConfigurationByName('chat')
    if (result.success) {
      let parsedData = JSON.parse(result.data.values)
      setConfigId(result.data.id)
      setMegaChatBotConfig({
        ...parsedData,
        isGlobalChatBotEnabled: parsedData.isGlobalChatBotEnabled,
        gestureImage: parsedData.gestureImage,
        globalChatBotName: parsedData.globalChatBotName,
        globalChatBotUrl: parsedData?.globalChatBotUrl,
      })
      setFile(parsedData.gestureImage)
    }
  }

  const onBlurUpdate = () => {
    updateConfiguration(megaChatBotConfig, file)
  }

  const updateConfiguration = async (config: any, fileUploaded: any) => {
    let result = await updateConfigurationByConfigID(configID, config, fileUploaded)

    if (result.success) {
      getConfiguration()
      setisImageUploaded(false)
      ToastUtils({type: 'success', message: 'Configuration Saved SuccessFully'})
    } else {
      ErrorToastUtils()
    }
  }

  const handleIconChange = (event: any) => {
    setisImageUploaded(true)
    const fileUploaded = event.target.files[0]
    //setFile(fileUploaded)
    updateConfiguration({...megaChatBotConfig}, fileUploaded)
  }

  const handleClick = () => {
    const fileInput = document.getElementById(`fileInput`)
    fileInput?.click()
  }

  let baseImageUrl = getImageBaseUrl()

  return (
    <div className='card'>
      <div className='card-title p-8'>
        <h2>Mega Chat Bot settings</h2>
      </div>
      <div className='card-body'>
        <div className='row no-gutters'>
          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Mega Chat Bot</strong>
            </p>
            <p className='text-muted'>Enable Or Disable Mega Chat Bot</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='form-check form-switch'>
              <input
                className='form-check-input'
                type='checkbox'
                role='switch'
                id='flexSwitchCheckDefault'
                name='isGlobalChatBotEnabled'
                checked={megaChatBotConfig.isGlobalChatBotEnabled}
                onChange={(event) => handleChange(event)}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Mega Chat Bot Name</strong>
            </p>
            <p className='text-muted'>-</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='flex'>
              <input
                type='text'
                className='form-control'
                name='globalChatBotName'
                value={megaChatBotConfig.globalChatBotName}
                onChange={(event) =>
                  setMegaChatBotConfig({
                    ...megaChatBotConfig,
                    globalChatBotName: event.target.value,
                  })
                }
                onBlur={onBlurUpdate}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Mega Chat Bot URL</strong>
            </p>
            <p className='text-muted'>-</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='flex'>
              <input
                type='text'
                className='form-control'
                name='globalChatBotUrl'
                value={megaChatBotConfig.globalChatBotUrl}
                onChange={(event) =>
                  setMegaChatBotConfig({
                    ...megaChatBotConfig,
                    globalChatBotUrl: event.target.value,
                  })
                }
                onBlur={onBlurUpdate}
              />
            </div>
          </div>

          <div className='col-lg-4 card-body bg-light'>
            <p>
              <strong className='headings-color'>Mega Chat Bot Image</strong>
            </p>
            <p className='text-muted'>Upload Image For Bot</p>
          </div>
          <div className='col-lg-8 card-form__body card-body d-flex align-items-center bg-white'>
            <div className='flex'>
              <div className='symbol symbol-70px overflow-visible me-3'>
                <img
                  src={
                    `${baseImageUrl}/${file}` ||
                    `https://preview.keenthemes.com/metronic8/react/demo1//media/avatars/300-6.jpg`
                  }
                  alt='icon'
                  loading='lazy'
                />
                <button
                  className='ms-4 btn btn-primary'
                  onClick={() => {
                    handleClick()
                    setisImageUploaded(false)
                  }}
                >
                  Choose Photo
                </button>

                <input
                  type='file'
                  name='icon'
                  id={`fileInput`}
                  onChange={(e) => handleIconChange(e)}
                  ref={hiddenFileInput}
                  style={{display: 'none'}} // Make the file input element invisible
                  accept='image/*'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MegaChatBotPlugin
